'use client';

import { IconSearch } from '@tabler/icons-react';
import React from 'react';
import { useMediaQuerySafe } from '@/hooks/useMediaQuerySafe';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export type SimpleSearchInputProps = {
  searchValue?: string;
  onChangeSearch: (str: string) => void;
  onClickSearch: () => void;
  leftPartComponent?: React.ReactNode;
  rightPartComponent?: React.ReactNode;
  filtersComponent?: React.ReactNode;
  compact?: boolean;
  placeholder?: string;
};

export const SimpleSearchInput: React.FC<SimpleSearchInputProps> = ({
  searchValue = '',
  onChangeSearch,
  onClickSearch,
  leftPartComponent,
  filtersComponent,
  rightPartComponent,
  compact = false,
  placeholder,
}) => {
  const isDesktop = useMediaQuerySafe('(min-width: 1024px)');
  const t = useTranslations('filters');
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isDesktop) return;
    if (event.key === 'Enter') {
      onClickSearch();
    }
  };

  if (compact) {
    return (
      <div className='w-full flex items-center gap-[8px] rounded-[10px] bg-bg2-day px-[12px] h-[44px] lg:h-[40px]'>
        <IconSearch className='w-[16px] h-[16px] text-text-disabled-day shrink-0' />
        <Input
          value={searchValue}
          onChange={(e) => onChangeSearch(e.target.value)}
          onKeyDown={handleKeyDown}
          className='h-auto grow rounded-none border-none bg-transparent p-0 shadow-none text-[14px] lg:text-[14px] text-primary focus-visible:ring-0'
          placeholder={placeholder ?? t('search_placeholder')}
        />
      </div>
    );
  }

  return (
    <div className='w-full flex justify-between gap-[16px] md:min-h-[66px]'>
      <div className='w-full rounded-[12px] bg-bg2-day flex gap-[16px] items-center p-[4px]'>
        {leftPartComponent && leftPartComponent}
        <Input
          value={searchValue}
          onChange={(e) => {
            onChangeSearch(e.target.value);
          }}
          onKeyDown={handleKeyDown}
          className='h-[36px] md:h-[52px] ms-[16px] lg:ms-0 rounded-none border-none bg-transparent p-0 shadow-none grow-2 text-[16px] md:text-[18px] leading-normal text-primary placeholder:text-text-secondary focus-visible:ring-0'
          placeholder={placeholder ?? t('search_placeholder')}
        />

        <div className='flex gap-[7px]'>
          {filtersComponent && filtersComponent}

          {/* </Suspense> */}
          <Button onClick={onClickSearch} size='icon' className='md:h-[52px] md:w-[52px] h-[36px] w-[36px]'>
            <IconSearch className='size-5 md:size-6 text-white' />
          </Button>
        </div>
      </div>
      {rightPartComponent && rightPartComponent}
    </div>
  );
};
